export class UltimateCustomerSearchDto {
    CustomerDescription: string;
    InstanceId: number;
}
export class UltimateCustomerDto {
    ID: number;
    Code: string;
    DisplayName: string;
}
